import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import Dashboard from './pages/Dashboard';
import Reviews from './pages/Reviews';
import NFCPlates from './pages/NFCPlates';
import AdminDashboard from './pages/AdminDashboard';
import CompanyDetail from './pages/CompanyDetail';
import AdminUsers from './pages/AdminUsers';
import RedirectPage from './pages/RedirectPage';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import GoogleBusiness from './pages/GoogleBusiness';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Redirection automatique selon l'état de connexion */}
          <Route path="/" element={<Home />} />
          
          {/* Authentification */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          
          {/* Dashboard protégé : risingcard.fr/app/dashboard */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* Reviews protégé : risingcard.fr/app/reviews */}
          <Route 
            path="/reviews" 
            element={
              <ProtectedRoute>
                <Reviews />
              </ProtectedRoute>
            } 
          />
          
          {/* NFC Plates protégé : risingcard.fr/app/nfc-plates */}
          <Route 
            path="/nfc-plates" 
            element={
              <ProtectedRoute>
                <NFCPlates />
              </ProtectedRoute>
            } 
          />
          
          {/* Google Business : risingcard.fr/app/google-business */}
          <Route
            path="/google-business"
            element={
              <ProtectedRoute>
                <GoogleBusiness />
              </ProtectedRoute>
            }
          />
          
          {/* Admin Dashboard : risingcard.fr/app/admin */}
          <Route 
            path="/admin" 
            element={
              <ProtectedAdminRoute>
                <AdminDashboard />
              </ProtectedAdminRoute>
            } 
          />
          
          {/* Company Detail : risingcard.fr/app/admin/company/:id */}
          <Route 
            path="/admin/company/:id" 
            element={
              <ProtectedAdminRoute>
                <CompanyDetail />
              </ProtectedAdminRoute>
            } 
          />

          {/* Admin Users : risingcard.fr/app/admin/users */}
          <Route
            path="/admin/users"
            element={
              <ProtectedAdminRoute>
                <AdminUsers />
              </ProtectedAdminRoute>
            }
          />
          
          {/* Admin vue entreprise : risingcard.fr/app/admin/company/:companyId/dashboard */}
          <Route
            path="/admin/company/:companyId/dashboard"
            element={
              <ProtectedAdminRoute>
                <Dashboard />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/company/:companyId/reviews"
            element={
              <ProtectedAdminRoute>
                <Reviews />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/company/:companyId/nfc-plates"
            element={
              <ProtectedAdminRoute>
                <NFCPlates />
              </ProtectedAdminRoute>
            }
          />

          {/* Redirect Page : risingcard.fr/app/link/:uniqueLink */}
          <Route path="/link/:uniqueLink" element={<RedirectPage />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
